// extracted by mini-css-extract-plugin
module.exports = {"small":"F-illustration-small-1sh9v","medium":"F-illustration-medium-2o8NC","large":"F-illustration-large-1edLj"};